export default __webpack_public_path__ + "static/media/warning.e1c59a2c.png";